import { Injectable } from '@angular/core';
import { CanLoad, Route, Router } from '@angular/router';
import { Store, AppState, AppFields, StorageUtil, take, Observable, map } from '../store';
import { ClubTeamsService } from '../services/club-teams.service';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment.prod';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AlertService } from '../services';

const SECRET_KEY = environment.secretKey;
@Injectable()
export class AuthFirebaseGuard implements CanLoad {

  public myTeam;
  subscriptionPlans: any;
  constructor(
    private store: Store<AppState>,
    private _service: ClubTeamsService,
    private loader: Ng4LoadingSpinnerService,
    private router: Router,
    private alert: AlertService,
  ) {
    this.store.select(AppFields.App, AppFields.MyTeam).subscribe(team => {
      this.myTeam = team;
    });
    this.store.select(AppFields.App, AppFields.SubscriptionPlans).subscribe((rs: any) => {
      this.subscriptionPlans = rs;
      //this.clubPlans = rs;
    });
  }

  canLoad(route: Route): boolean {
    if (this.subscriptionPlans && this.subscriptionPlans.hasClubMobileAppPlan) {
      if (localStorage.getItem('firebaseConfig') == undefined || localStorage.getItem('firebaseConfig') == null) {
        this.loader.show();
        this._service.getFirebaseProjectConfigDataByClubID(StorageUtil.clubID).pipe(take(1)).subscribe((res: any) => {
          if (res && res.data) {
            if (res.data.firebaseWebConfigJSON) {
              localStorage.setItem("firebaseConfig", this.encrypt(res.data.firebaseWebConfigJSON));
            }
            if (localStorage.getItem('firebaseConfig') != undefined || localStorage.getItem('firebaseConfig') != null) {
              if (!this.myTeam) {
                this.loader.show();
                this.router.navigate(["/communication-center/mobile-app-dashboard"]);
              } else {
                this.loader.hide();
              }

              if (this.myTeam) {
                this.router.navigate(["/communication-center-team/mobile-app-dashboard/messages"]);
              } else {
                this.loader.hide();
              }
            } else {
              this.loader.hide();
            }
            return true;
          } else {
            this.loader.hide();
            return false;
          }
        },
          error => {
            this.alert.error("Something went wrong.");
            this.loader.hide();
          }
        );
      } else {
        return true;
      }
    } else {
      this.router.navigate(["/communication-center/mobile-app-subscription-dashboard"]);
      return false;
    }
  }
  encrypt(payload: any) {
    const data = CryptoJS.AES.encrypt(JSON.stringify(payload), SECRET_KEY);
    return data.toString();
  }

}



// WEBPACK FOOTER //
// ./src/app/guards/auth.firebase.ts